import { ElLoading } from "element-plus";

let loading = null;

export default {
  show(text = "加载中") {
    try {
      loading = ElLoading.service({
        lock: true,
        text,
        background: "rgba(0, 0, 0, 0.7)",
      });
      return loading;
    } catch {
      loading = null;
      return null;
    }
  },
  hide() {
    try {
      if (loading && typeof loading.close === "function") {
        loading.close();
      }
    } finally {
      loading = null;
    }
  },
};
